import { Box } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import "react-quill/dist/quill.snow.css";
import { Fornecedores, Pacote } from "../../types";
import Input from "../inputs/Input.component";

interface FormFornecedoresProps {
  initialValues?: Fornecedores | null;
  onSubmit: (values: Fornecedores) => Promise<unknown>;
  loading?: boolean;
}

export interface FormFornecedoresRef {
  submit: () => Promise<void>;
}

export const FormFornecedores = forwardRef<
  FormFornecedoresRef,
  FormFornecedoresProps
>((props, ref) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Fornecedores>();

  useEffect(() => {
    if (props.initialValues) {
      reset(props.initialValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.initialValues]);

  const onSubmit: SubmitHandler<Fornecedores> = (values) => {
    props.onSubmit(values);
  };

  // Exposing the submit function via ref
  useImperativeHandle(ref, () => ({
    submit: handleSubmit(onSubmit),
  }));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
      <Input
        label="Nome"
        {...register("nome", { required: "O campo não pode estar em branco" })}
        loading={props.loading}
        error={!!errors.nome}
        helperText={errors.nome?.message}
        required
      />
      <Input
        label="Empresa"
        {...register("empresa", {
          required: "O campo não pode estar em branco",
        })}
        loading={props.loading}
        error={!!errors.empresa}
        helperText={errors.empresa?.message}
        required
      />
      <Input
        label="Email"
        {...register("email")}
        loading={props.loading}
        error={!!errors.email}
        helperText={errors.email?.message}
      />
      <Input
        label="Telefone"
        {...register("telefone")}
        loading={props.loading}
        error={!!errors.telefone}
        helperText={errors.telefone?.message}
      />
      <Input
        label="Descrição"
        {...register("descricao")}
        rows={4}
        loading={props.loading}
        multiline
        error={!!errors.descricao}
        helperText={errors.descricao?.message}
      />
    </Box>
  );
});
